<template>
  <div class="flex sm12 xs12">
    <div>
      <va-card :title="$t('planUpdate.cards.planItems')">
        <va-data-table
          :fields="fields"
          :data="plan_items"
          :per-page="perPage"
          :totalPages="totalPages"
          :loading="loading"
          @page-selected="showMore"
          no-data-label="Sem Dados Cadastrados"
          api-mode
        >
          <template
            slot="actions"
            slot-scope="props"
          >
            <a
              @click='check(props.rowData.id, props.rowData.selecteds.some(v => v.plan_id == planId))'
            >

              <va-checkbox
                :value='props.rowData.selecteds.some(v => v.plan_id == planId)'
              />
            </a>
          </template>
        </va-data-table>
      </va-card>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
const perPage = 10
export default {
  name: 'TablePlanItems',
  props: {
    planId: {
      required: true,
    },
  },
  data () {
    return {
      perPage: perPage,
      plan_items: [],
      page: 1,
      showAdd: false,
      pages: null,
      loading: false,
      modalDeletar: false,
      deleteId: 0,
      titleCard: '',
      updateId: null,
    }
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'description',
        title: this.$t('planUpdate.items.description'),
        width: '70%',
      }, {
        name: '__slot:actions',
        title: this.$t('planUpdate.tables.options'),
        dataClass: 'text-center',
      }]
    },
  },
  apollo: {
    plan_items: {
      query: gql`
      query MyQuery($page: Int, $perPage: Int) {
        plan_items: plan_item(limit: $perPage, offset: $page, order_by: {id: asc}) {
          id
          description
          selecteds: plan_item_selecteds {
            plan_id
          }
        }
      }
      `,
      variables () {
        return {
          perPage: this.perPage,
          page: 0,
        }
      },
    },
    pages: {
      query: gql`
      query MyQuery {
        pages: plan_item_aggregate {
          aggregate {
            count
          }
        }
      }
      `,
    },
  },
  methods: {
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.plan_items.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    check (itemId, option) {
      this.$apollo
        .mutate({
          mutation: option ? gql`
            mutation MyMutation($plan_id: Int!, $plan_item_id: Int!) {
              delete_plan_item_selected(where: {_and: {plan_id: {_eq: $plan_id}, plan_item_id: {_eq: $plan_item_id}}}) {
                affected_rows
              }
            }
          ` : gql`
            mutation MyMutation($plan_id: Int!, $plan_item_id: Int!) {
              insert_plan_item_selected_one(object: {plan_id: $plan_id, plan_item_id: $plan_item_id}) {
                id
              }
            }
          `,
          variables: {
            plan_id: this.planId,
            plan_item_id: itemId,
          },
        })
        .then(data => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.showToast(
            this.$t('toasts.successUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style>

</style>
